import React from 'react'
import Logo from '../../assets/MALogo.svg'

const NotFound = () => {
  return (
    <div className='wrapper'>
      <div className='d-flex flex-column justify-content-center align-items-center' style={{minHeight: '100vh'}}>
        <div className='d-flex mb-2' style={{cursor: 'pointer'}} onClick={() => window.location.href='/'}>
            <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
            <h2 style={{fontWeight: 600}}>Melee Academy</h2>
        </div>
        <h5>404: NotFound</h5>
        <p style={{fontWeight: 300}}>Didn't find the page you were looking for.</p>
        <button
          className='rounded mt-3'
          style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, width: "150px"}}
          onClick={() => window.location.href='/'}
        >
          Go Home
        </button>
      </div>
    </div>
  )
}

export default NotFound